import { PayloadAction } from '@reduxjs/toolkit';
import { FormatState } from 'src/store/format/types';

const setAllFormatsAreLoadedReducer = (state: FormatState, action: PayloadAction<boolean>) => {
  state.allFormatsAreLoaded = action.payload;
};

export default setAllFormatsAreLoadedReducer;
